export const DASHBOARD_COLUMNS = {
  date: ['Date', 'day', 'timestamp'],
  impressions: ['Ad server Impressions', 'Impressions', 'total impressions'],
  clicks: ['Total Clicks', 'Clicks', 'total clicks'],
  served: ['Total Code Served Count', 'Code Served', 'serve count'],
  ctr: ['Total CTR', 'Click Rate (CTR)', 'CTR', 'ctr'],
  geo: ['Geo', 'location', 'region', 'city', 'GEO'],
  publisher: [
    'Publisher Name',
    'Publisher',
    'App/URL',
    'site',
    'app name',
    'App Name',
  ],
};

// Columns already consumed by the KPI cards and fixed charts — anything else in
// the sheet is treated as an extra dimension and gets its own breakdown card
export const RESERVED_DASHBOARD_COLUMNS = new Set(
  [...Object.values(DASHBOARD_COLUMNS).flat(), 'Tab Name'].map(c =>
    c.toLowerCase()
  )
);

// Column names that mean "this is a whole-number count" / "this is a percentage"
export const COUNT_COLUMN_KEYS = [
  'count',
  'impressions',
  'clicks',
  'served',
  'total',
  'reach',
];
export const PERCENT_COLUMN_KEYS = ['ctr', 'rate', '%'];
